// src/components/ui/avatar.jsx

"use client"

import * as React from "react";
import * as AvatarPrimitive from "@radix-ui/react-avatar";
import PropTypes from 'prop-types';

import { cn } from "../../lib/utils.js"

const Avatar = React.forwardRef(({ className, ...props }, ref) => (
    <AvatarPrimitive.Root
        ref={ref}
        className={cn(
            "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
            className
        )}
        {...props}
    />
));
Avatar.displayName = AvatarPrimitive.Root.displayName;

const AvatarImage = React.forwardRef(({ className, ...props }, ref) => (
    <AvatarPrimitive.Image
        ref={ref}
        className={cn("aspect-square h-full w-full", className)}
        {...props}
    />
));
AvatarImage.displayName = AvatarPrimitive.Image.displayName;

const AvatarFallback = React.forwardRef(({ className, ...props }, ref) => (
    <AvatarPrimitive.Fallback
        ref={ref}
        className={cn(
            "flex h-full w-full items-center justify-center rounded-full bg-muted",
            className
        )}
        {...props}
    />
));
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;


// --- PropTypes ---
Avatar.propTypes = {
    className: PropTypes.string,
};

AvatarImage.propTypes = {
    className: PropTypes.string,
    src: PropTypes.string, // Image URL (optional)
};

AvatarFallback.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired, // Initials kiva icon आवश्यक आहे
};


export { Avatar, AvatarImage, AvatarFallback };